import supabase from "../config/supabase";
const feedbackApi = {
  async list({status = "open", offset = 0} = {}) {
    try {
      let query = supabase.from("feedback_submissions")
        .select("*, author:users!author_id(id, first_name, last_name)")
        .order("created_at", {ascending: false}).order("id", {ascending: false}).range(offset, offset + 49);
      if (status !== "all") query = query.eq("status", status);
      const {data, error} = await query;
      return error ? {success: false, error: "Feedback couldn’t load. Please try again."} : {success: true, data: data || []};
    } catch (_) {return {success: false, error: "Feedback couldn’t load. Please try again."};}
  },
  async setStatus(id, status) {
    try {
      const {error} = await supabase.rpc("admin_set_feedback_status", {p_id: id, p_status: status});
      return error ? {success: false, error: "The status couldn’t be saved. Please try again."} : {success: true};
    } catch (_) {return {success: false, error: "The status couldn’t be saved. Please try again."};}
  },
  async submit(feedback, requestId) {
    try {
      const {data, error} = await supabase.rpc("submit_feedback", {
        p_id: requestId, p_type: feedback.type, p_rating: feedback.rating,
        p_title: feedback.title.trim(), p_description: feedback.description.trim(),
      });
      if (error) return {success: false, error: "Your feedback could not be sent. Please try again."};
      return {success: true, data};
    } catch (_) {
      return {success: false, error: "Your feedback could not be sent. Please try again."};
    }
  },
};
export default feedbackApi;
